import { Grid, makeStyles, Theme, Typography } from '@material-ui/core';
import * as d3 from 'd3';
import React from 'react';

export interface ItemProps {
  label: string;
  volume: number;
}

const numberFormatter = d3.format('.2s');

export const useClasses = makeStyles((theme: Theme) => ({
  item: {
    paddingTop: theme.spacing(0.25),
  },
}));

export const Item: React.FC<ItemProps> = ({ label, volume }) => {
  const classes = useClasses();
  return (
    <Grid item>
      <Typography variant="body2" display="block" className={classes.item} noWrap>
        {label}{' '}
        <Typography component="span" variant="caption" display="inline" color="textSecondary">
          ({numberFormatter(volume)})
        </Typography>
      </Typography>
    </Grid>
  );
};

export default Item;
